<div echarts
     [options]="options"
     [merge]="updateOptions"
     [initOpts]="initOptions"
     [autoResize]="true"
     (chartInit)="onChartInit($event)"
     (chartDataZoom)="onChartDataZoom($event)"
     (chartMagicTypeChanged)="onChartMagicTypeChanged($event)"
     (chartClick)="onChartClick($event)"
     style="height: 100%"
></div>
<button #expandBtn type="button" style="display: none" (click)="onExpandClick()">&nbsp;</button>
